// extracted by mini-css-extract-plugin
module.exports = {"logo":"Home_logo__DInjW"};